var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import * as _ from "lodash";
export var PluginActionTypes = {
    /** Actions available for plugins! **/
    BATCH_ACTIONS: 0,
    SET_POSTS: 2,
    SET_CAPABILITIES: 3,
    ADD_APPENTRIES: 4,
    ADD_MODULES: 5,
    SET_MODULE_BADGE: 6,
    OPEN_SINGLE_MODULE: 7,
    OPEN_MODULE: 8,
    SET_APPLICATION_NAME: 9,
    SET_ROUTE: 10,
    SET_BUTTONS: 11,
    PLUGIN_ACTIONS_END: 1000,
};
export var returnNewState = function (state) {
    return __assign(__assign({}, state), { activeModules: _.filter(state.modules, function (m) { return !m.available || m.available(state); }) });
};
export var pluginReducer = function (state, action, mainReducer) {
    if (action.type > PluginActionTypes.PLUGIN_ACTIONS_END)
        return state;
    switch (action.type) {
        case PluginActionTypes.BATCH_ACTIONS: {
            var s_1 = __assign({}, state);
            _.forEach(action.actions, function (a) {
                s_1 = mainReducer(s_1, a);
            });
            return s_1;
        }
        case PluginActionTypes.SET_POSTS:
            return __assign(__assign({}, state), { posts: action.posts });
        case PluginActionTypes.ADD_MODULES:
            {
                var mods = __spreadArrays(state.modules, action.modules);
                return returnNewState(__assign(__assign({}, state), { modules: mods }));
            }
        case PluginActionTypes.ADD_APPENTRIES:
            return returnNewState(__assign(__assign({}, state), { appEntries: __spreadArrays(state.appEntries, action.appEntries) }));
        case PluginActionTypes.SET_MODULE_BADGE:
            return returnNewState(__assign(__assign({}, state), { modules: _.map(state.modules, function (m) {
                    var _a;
                    if (m === action.module)
                        m.badge = (action.add ? ((_a = m.badge) !== null && _a !== void 0 ? _a : 0) : 0) + action.badge;
                    return m;
                }) }));
        case PluginActionTypes.OPEN_MODULE:
            return returnNewState(__assign(__assign({}, state), { modules: _.map(state.modules, function (m) {
                    if (m === action.moduleToOpen)
                        m.open = action.open;
                    return m;
                }) }));
        case PluginActionTypes.OPEN_SINGLE_MODULE:
            console.log(action);
            return returnNewState(__assign(__assign({}, state), { modules: _.map(state.modules, function (m) {
                    if (m === action.moduleToOpen)
                        m.open = true;
                    else if (m.open && _.findIndex(action.modulesToClose, function (mtc) { return mtc === m; }) >= 0)
                        m.open = false;
                    return m;
                }) }));
        case PluginActionTypes.SET_APPLICATION_NAME:
            console.log(action);
            return returnNewState(__assign(__assign({}, state), { applicationName: action.applicationName }));
        case PluginActionTypes.SET_ROUTE:
            console.log(action);
            return returnNewState(__assign(__assign({}, state), { route: action.route }));
        case PluginActionTypes.SET_BUTTONS:
            console.log(action);
            return returnNewState(__assign(__assign({}, state), { buttons: action.buttons }));
    }
    return state;
};
export var PluginActions = {
    batchActions: function (actions) {
        return { type: PluginActionTypes.BATCH_ACTIONS, actions: actions };
    },
    setPosts: function (posts) {
        return { type: PluginActionTypes.SET_POSTS, posts: posts };
    },
    addAppEntries: function (appEntries) {
        return { type: PluginActionTypes.ADD_APPENTRIES, appEntries: _.isArray(appEntries) ? appEntries : [appEntries] };
    },
    addModules: function (modules) {
        return { type: PluginActionTypes.ADD_MODULES, modules: _.isArray(modules) ? modules : [modules] };
    },
    setModuleBadge: function (module, badge, add) {
        return { type: PluginActionTypes.SET_MODULE_BADGE, module: module, badge: badge, add: add };
    },
    openSingleModule: function (moduleToOpen, modulesToClose) {
        return { type: PluginActionTypes.OPEN_SINGLE_MODULE, moduleToOpen: moduleToOpen, modulesToClose: modulesToClose };
    },
    openModule: function (moduleToOpen, open) {
        return { type: PluginActionTypes.OPEN_MODULE, moduleToOpen: moduleToOpen, open: open };
    },
    setApplicationName: function (applicationName) {
        return { type: PluginActionTypes.SET_APPLICATION_NAME, applicationName: applicationName };
    },
    setRoute: function (route) {
        return { type: PluginActionTypes.SET_ROUTE, route: route };
    },
    setButtons: function (buttons) {
        return { type: PluginActionTypes.SET_BUTTONS, buttons: buttons };
    },
};
